// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* ONLY place styles here which are just relevant for web. (There will not be many.) */\r\n\r\nbody {\r\n  overscroll-behavior-x: none;\r\n}\r\n\r\na {\r\n  text-decoration: none;\r\n}\r\n\r\na:hover {\r\n  opacity: .7;\r\n}\r\n\r\ninput {\r\n  outline: none !important;\r\n}\r\n\r\n.VictoryContainer > svg {\r\n  overflow: visible;\r\n}", ""]);
// Exports
module.exports = exports;
